module.exports = __webpack_public_path__ + "YoungSerif-Regular.fff0558ba65c52129ee9.woff";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/YoungSerif-Regular.woff
// module id = ../../../../../src-admin/assets/fonts/YoungSerif-Regular.woff
// module chunks = styles